import styled from 'styled-components'
import FirstColumn from './FirstColumn'
import SecondColumn from './SecondColumn'
import noImageBottle from './_assets/no-bottle-image.svg'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 46px 0;
  height: 1092px;
  box-sizing: border-box;
`

const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  width: 306px;
  height: 930px;
  margin: 0 58px;
  background: url('${props => props.src || noImageBottle}') no-repeat center;
  background-size: contain;
`

const Columns = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding-right: 48px;
`

const Content = ({ product }) => {
  const bottleImage = product?.bottleImage?.imageUrl

  return (
    <Wrapper>
      <Image src={bottleImage} />
      <Columns>
        <FirstColumn product={product} />
        <SecondColumn product={product} />
      </Columns>
    </Wrapper>
  )
}

export default Content
